module.exports = __webpack_public_path__ + "img/new_index_industry_bg.1bcaebaa.jpg";